import { createContext, ReactNode, useContext } from 'react';
import { FileSystemInterface } from './FileSystemInterface';

type FileSystemContextType = {
  fileSystem: FileSystemInterface;
};

const FileSystemContext = createContext<FileSystemContextType | undefined>(undefined);

export const FileSystemContextProvider = ({ children, fileSystem }: { children: ReactNode; fileSystem: FileSystemInterface }) => {
  return <FileSystemContext.Provider value={{ fileSystem }}>{children}</FileSystemContext.Provider>;
};

export const useFileSystem = (): FileSystemInterface => {
  const context = useContext(FileSystemContext);
  if (!context) {
    throw new Error('useFileSystem must be used within a FileSystemContextProvider');
  }
  return context.fileSystem;
};
